import './dot-navigation.css';

function DotNavigation({
  items = [],
  activeId,
  onSelect,
  ariaLabel,
  getItemAriaLabel = item => item.label,
  className = '',
}) {
  return (
    <div
      aria-label={ariaLabel}
      className={`dot-navigation ${className}`.trim()}
      role="tablist"
    >
      {items.map((item) => {
        const isActive = item.id === activeId;

        return (
          <button
            aria-label={getItemAriaLabel(item)}
            aria-selected={isActive}
            className={`dot-navigation__dot${isActive ? ' dot-navigation__dot--active' : ''}`}
            disabled={isActive}
            key={item.id}
            onClick={() => onSelect(item.id)}
            role="tab"
            type="button"
          />
        );
      })}
    </div>
  );
}

export default DotNavigation;
